<div class="order-panel-list">
  <div class="order-panel-item" *ngFor="let order of orders; let i = index; let last = last">
    <div class="order-header" (click)="togglePanel(i)">
      <div class="order-main-info">
        <div class="order-identifier">
          <span class="label">{{ 'components.orderPanel.identifier' | i18n }}</span>
          <span class="value">{{ order.identifier || '-' }}</span>
        </div>
        <div class="separator">|</div>
        <div class="order-date">
          <span class="label">{{ 'components.orderPanel.orderDate' | i18n }}</span>
          <span class="value">{{ formatDate(order.orderDate) }}</span>
        </div>
        <div class="separator">|</div>
        <div class="order-total">
          <span class="label">{{ 'components.orderPanel.total' | i18n }}</span>
          <span class="value">
            @if (order.total !== null) {
              {{ getDisplayTotal(order) | currencyBRL }}{{ getTotalSuffix(order) }}
            } @else {
              -
            }
          </span>
        </div>
      </div>
      <div class="order-actions-row font-highlight">
        <div class="order-status">
          <span class="status-badge" [ngClass]="getStatusClass(order.status)">
            <span
              class="status-icon"
              [ngClass]="order.statusIcon.class"
              [style.color]="order.statusIcon.color"
              [attr.aria-label]="order.statusIcon.label"
            ></span>
            <span class="status-text">
              {{ order.statusTranslationKey | i18n }}
            </span>
          </span>
        </div>
        <span class="material-icons toggle-icon">
          {{ isPanelOpen(i) ? 'expand_less' : 'expand_more' }}
        </span>
      </div>
    </div>

    <div class="order-content" *ngIf="isPanelOpen(i)">
      <div class="products-grid">
        <div class="product-card" *ngFor="let product of order.products">
          <div class="product-name">{{ getFormattedProductName(product) }}</div>
          <div class="product-details">
            <div class="product-quantity">
              {{ product.quantity }}{{ ' ' }}{{ (product.quantity > 1 ? 'components.orderPanel.signaturePlural' : 'components.orderPanel.signatureSingular') | i18n }}
            </div>
            <div class="product-price">
              @if (isFreeProductPrice(product)) {
                <span class="product-price-free-badge">{{ 'components.orderPanel.free' | i18n }}</span>
              } @else if (getMindListPrice(product, order); as mindPromo) {
                @if (mindPromo.hasPromotion) {
                  <div class="product-price-mind">
                    <span class="product-price-mind__value">
                      {{ mindPromo.displayPrice | currencyBRL }}/mês
                    </span>
                    <span class="product-price-mind__hint">
                      <span>{{ getMindPromoDurationKey(mindPromo) | i18n: { count: mindPromo.promotionMonths } }}</span>
                      <span>{{ 'components.productCard.promoAfterMonthly' | i18n: { price: formatMindOriginalPrice(mindPromo.originalPrice) } }}</span>
                    </span>
                  </div>
                } @else {
                  {{ mindPromo.displayPrice | currencyBRL }}
                }
              } @else if (getMonthlySuffix(product, order); as priceSuffix) {
                <div class="product-price-recurring">
                  <span>{{ getMonthlyPrice(product, order) | currencyBRL }}{{ priceSuffix }}</span>
                  <span class="product-price-unit">{{ 'components.orderPanel.perSignature' | i18n }}</span>
                </div>
              } @else {
                {{ getMonthlyPrice(product, order) | currencyBRL }}
              }
            </div>
          </div>
        </div>
      </div>

      <div class="order-footer">
        <div class="order-actions">
          @if (order.creditAnalysisRejected === true && order.paymentMethod !== 'MIND') {
            <button
              type="button"
              class="btn-details btn-retry-card"
              [disabled]="!order.products.length"
              (click)="onRetryWithCardClick(order, $event)"
            >
              {{ 'components.orderPanel.retryWithCard' | i18n }}
            </button>
          }
          <button
            class="btn-details"
            [class.btn-plans]="order.status === 'completo'"
            [disabled]="!order.status || !order.identifier"
            (click)="onButtonClick(order)"
          >
            {{ (order.status === 'completo' ? 'components.orderPanel.viewPlans' : 'components.orderPanel.viewDetails') | i18n }}
          </button>
        </div>
      </div>
    </div>

    <div class="panel-divider" *ngIf="!last"></div>
  </div>
</div>
